<template>
<div class="row">
    <div class="col-sm-12">
        <div class="lottie-box">
            <lottie-player :src="image_url" background="transparent" speed="1" loop autoplay></lottie-player>
        </div>
    </div>
</div>
</template>
  
<script>
export default {
  data() {
    return {};
  },
  props: {
    image_url: { type: String, default:'' }
  },
  methods: {},
};
</script>
